export const API_URL =
  import.meta.env.PUBLIC_API_URL || 'https://api-wallet.nyv.app';
